import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'analysis-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  constructor(
    public dialogFinish: MatDialogRef<ModalComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  modalInfos: { title: any; message: any; error: any; button: any };

  ngOnInit(): void {
    this.modalInfos = {
      title:
      this.data?.content?.title ||
      'Houve um problema ao processar sua solicitação.',
      message: this.data?.content?.message || 'Por favor, tente novamente.',
      error: this.data?.content?.err || 'Ocorreu um erro inesperado.',
      button: this.data?.content?.button || 'Entendi',
    };
  }

  closeDialog(event?: string): void {
    if (this.data?.content?.type === 'queue') {
      this.navigateHome();
    }

    if (this.data.content.type === 'newQueue') {
      window.location.reload();
    }

    return this.dialogFinish.close({ finalize: true });
  }

  navigateHome() {
    this.router.navigate(['/']);
  }
}
